import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { XMarkIcon } from '@heroicons/react/24/outline';
import './Sidebar.css';
import useEnergy from '../hooks/useEnergy';
import {
  SidebarBrand,
  SidebarSection,
  SidebarEnergy,
  sidebarSections
} from './sidebar/index';

const Sidebar = ({ isMobileOpen = false, onNavigateComplete = () => {}, onClose = () => {} }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userEnergy } = useEnergy();

  const isActive = (path) => location.pathname === path;
  const handleNavigate = (path) => {
    navigate(path);
    onNavigateComplete();
  };

  return (
    <aside className={`mp-sidebar ${isMobileOpen ? 'is-mobile-open' : ''}`}>
      <div className="mp-sidebar__header">
        <SidebarBrand />
        <button type="button" className="mp-sidebar__mobile-close" onClick={onClose} aria-label="Fechar menu">
          <XMarkIcon className="mp-sidebar__mobile-close-icon" />
        </button>
      </div>

      <nav className="mp-sidebar__nav">
        {sidebarSections.map((section) => (
          <SidebarSection
            key={section.title}
            title={section.title}
            items={section.items}
            isActive={isActive}
            onNavigate={handleNavigate}
          />
        ))}
      </nav>

      <div className="mp-sidebar__footer">
        <SidebarEnergy userEnergy={userEnergy} />
      </div>
    </aside>
  );
};

export default Sidebar;
